/* istanbul ignore file */

const getInternal = () =>
    Object.freeze({
        PRODUCTION: process.env.NODE_ENV === "production",
        DEVELOPMENT: process.env.NODE_ENV === "development",
        DEV_URL_OVERRIDE: process.env.DEV_URL_OVERRIDE || "",
        NODE_ENV: process.env.NODE_ENV,
        REACT_APP_PLATMOD_CDN_BASEURL: process.env.REACT_APP_CDN_BASEURL
            ? `${process.env.REACT_APP_CDN_BASEURL}/platmod`
            : "https://xcdn.next.co.uk/content/platmod",
        REACT_APP_BLOB_STORAGE_PATH: "/static-content",
    })

const INTERNAL = getInternal()

const getEnvVars = () =>
    Object.freeze({
        REACT_APP_BLOB_STORAGE_SSR_BASEURL:
            process.env.REACT_APP_BLOB_STORAGE_SSR_BASEURL || "https://ecmbrowsefdsxeuw.azurefd.net",
        PORT: process.env.PORT || 3002,
        REACT_APP_CDN_BASEURL: process.env.REACT_APP_CDN_BASEURL
            ? process.env.REACT_APP_CDN_BASEURL
            : "https://xcdn.next.co.uk/content",
        REACT_APP_API_BASEURL: process.env.REACT_APP_API_BASEURL
            ? process.env.REACT_APP_API_BASEURL
            : "https://ci-test.next.co.uk/api",
        POD_NAME: process.env.POD_NAME,
        LOG_LEVEL: process.env.LOG_LEVEL,
        REACT_APP_APPINSIGHTS_KEY: process.env.REACT_APP_APPINSIGHTS_KEY,
        REACT_APP_ENTRYPOINT: process.env.REACT_APP_ENTRYPOINT || "/footer",
        ASSETS_PATH: process.env.ASSETS_PATH || "/footerstatic",
        USE_LOCAL_STATIC_CONTENT: process.env.USE_LOCAL_STATIC_CONTENT || "true",
        REACT_APP_SERVE_PATH_PREFIX: process.env.REACT_APP_SERVE_PATH_PREFIX || "",
        ENVIRONMENT_NAME: process.env.ENVIRONMENT_NAME || "pd",
        REACT_APP_LAUNCH_DARKLY_SDK_KEY: process.env.REACT_APP_LAUNCH_DARKLY_SDK_KEY,
    })

export const getVars = () => ({...INTERNAL, ...getEnvVars()})

export default getVars()
